import { FIXED_INDENTS, INDENTS, LAYOUT } from 'vars/index'

export const ContainerHeaderDirection = {
  Row: 'row',
  Column: 'column',
} as const
export type ContainerHeaderDirection =
  (typeof ContainerHeaderDirection)[keyof typeof ContainerHeaderDirection]

export const ContainerHeaderJustifyContent = {
  FlexStart: 'flex-start',
  Center: 'center',
  FlexEnd: 'flex-end',
  SpaceBetween: 'space-between',
  SpaceAround: 'space-around',
  SpaceEvenly: 'space-evenly',
} as const
export type ContainerHeaderJustifyContent =
  (typeof ContainerHeaderJustifyContent)[keyof typeof ContainerHeaderJustifyContent]

export const ContainerHeaderAlignItems = {
  FlexStart: 'flex-start',
  Center: 'center',
  FlexEnd: 'flex-end',
  Baseline: 'baseline',
} as const
export type ContainerHeaderAlignItems =
  (typeof ContainerHeaderAlignItems)[keyof typeof ContainerHeaderAlignItems]

export const ContainerHeaderColumnGap = {
  INDENT_40: INDENTS.INDENT_40,
  INDENT_60: INDENTS.INDENT_60,
  INDENT_90: INDENTS.INDENT_90,
} as const
export type ContainerHeaderColumnGap =
  (typeof ContainerHeaderColumnGap)[keyof typeof ContainerHeaderColumnGap]

export const ContainerHeaderRowGap = {
  INDENT_10: INDENTS.INDENT_10,
  INDENT_20: INDENTS.INDENT_20,
  INDENT_30: INDENTS.INDENT_30,
} as const
export type ContainerHeaderRowGap =
  (typeof ContainerHeaderRowGap)[keyof typeof ContainerHeaderRowGap]

export const ContainerHeaderPaddings = {
  NONE: [FIXED_INDENTS.INDENT_0],
  DEFAULT: [FIXED_INDENTS.INDENT_0, LAYOUT.HorizontalPaddings],
}
